import {
  ButtonType,
  ButtonWidget
} from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../commonInfra/utils/ImgUrl';
import { AddNewPermissionStyles } from '../styles/AddNewPermissionStyle';

export type AddNewPermissionProps = AddNewPermissionStyles.AddNewPermissionContainerStyleArgs & {
  disabled: boolean;
  onClick: () => void;
};

export class AddNewPermission extends React.PureComponent<AddNewPermissionProps, {}>{
  public static readonly BUTTON_ID = 'add-new-permission-button';

  private getButtonContent = (): JSX.Element => {
    const imgSrc: string = this.props.disabled ? imgPath('permission_rule_add_disabled.svg') : imgPath('permission_rule_add.svg');
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <span className={ AddNewPermissionStyles.ButtonContent }>
        <img
          aria-hidden={ true }
          src={ imgSrc }
        />
        { Messages.permissionRuleAdd() }
      </span>
    );
  };

  public render() {
    const { numAddedRows, searching } = this.props;
    const containerClassName = AddNewPermissionStyles.memoizedButtonContainer({ numAddedRows, searching });
    return (
      <div className={ containerClassName }>
        <ButtonWidget
          buttonType={ ButtonType.Outline }
          disabled={ this.props.disabled }
          getContent={ this.getButtonContent }
          handleClick={ this.props.onClick }
          testId={ AddNewPermission.BUTTON_ID }
        />
      </div>
    );
  }
}
